import { routes } from "src/shared/routes";
import { FAQS, REGISTRATION_CARDS } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const predators_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "predators_upgrades",
  TEAM_FULL_NAME: "Nashville Predators",
  BROWSER_TITLE: "Let’s get you to the game!",
  CLIENT_ID: "dfd8b5e4f0c4.seasonshare.predators-predator.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#041E42",
    COLORS_SECONDARY: "#FFB81C",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    LOGOUT_ON_INVALID_SESSION: true,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    ENABLE_ADD_ON_PURCHASE_SUCCESS_PAGE: true,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/predators/",

    NAV_MENU: {
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_EARN_REWARDS: true,
    },
    FOOTER: {
      BACKGROUND_COLOR: "#FFB81C",
    },
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024/Nashville-Predators-2024-transparent-bg.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024/Nashville-Predators-v3/SeatUpgrades_375x550.jpg",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024/Nashville-Predators-v3/SeatUpgrades_1920x450.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024/Nashville-Predators-v3/SeatUpgrades_375x550.jpg",

    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024/Nashville-Predators-v3/SeatUpgrades_1920x450.jpg",
  },

  LANGUAGES: {
    FAQS,
  },
};
